import api from "./api";

/* GET */
export const apiGet = (url, params = {}) => {
  return api.get(url, { params });
};

/* POST */
export const apiPost = (url, data) => {
  return api.post(url, data);
};

/* PUT */
export const apiPut = (url, data) => {
  return api.put(url, data);
};

/* DELETE */
export const apiDelete = (url) => {
  return api.delete(url);
};
